(() => {
  const styleCache = new Map();     // style -> Promise(products[])
  const rendered = new WeakSet();   // DOM nodes already rendered

function handleize(str) {
  return (str || "")
    .normalize("NFD")                 // split accented letters
    .replace(/[\u0300-\u036f]/g, "")  // remove accent marks
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

  function getSwatchUrl20(colorway) {
    if (!window.SWATCH_FILE_TEMPLATE_20) return null;

    // Shopify file_img_url('20x20') pattern gives: x_20x20.png
    // We swap filename to: gold-ruby_20x20.png
    const filename = `${handleize(colorway)}_20x20.png`;
    return window.SWATCH_FILE_TEMPLATE_20.replace(/x_20x20\.png$/, filename);
  }

  async function fetchProductsForStyle(style) {
    const q = encodeURIComponent(style);
    const res = await fetch(
      `/search/suggest.json?q=${q}&resources[type]=product&resources[limit]=20`,
      { credentials: "same-origin" }
    );
    const data = await res.json();

    // Exact siblings only: "Style - Colorway"
    return (data?.resources?.results?.products || []).filter(p =>
      p.title.startsWith(style + " -")
    );
  }

  function getProductsForStyle(style) {
    if (!styleCache.has(style)) {
      styleCache.set(style, fetchProductsForStyle(style).catch(() => []));
    }
    return styleCache.get(style);
  }

  function renderSwatches(container, products) {
    if (rendered.has(container)) return;
    rendered.add(container);

    const currentId = container.dataset.currentId;
    if (!products || products.length <= 1) return;

    const ul = document.createElement("ul");
    ul.className = "pdp_op_content";
    ul.style.marginInlineStart = "0em";

    products.forEach(p => {
      const colorway = p.title.split(" - ")[1]; // e.g. Gold|Ruby
      if (!colorway) return;

      const li = document.createElement("li");

      const a = document.createElement("a");
      a.href = new URL(p.url, window.location.origin).pathname;
      a.setAttribute("aria-label", colorway);
      a.dataset.tooltip = colorway;

      const sw = document.createElement("div");
      sw.className = "plp_swatch";
      if (String(p.id) === String(currentId)) sw.classList.add("current");

      const swUrl = getSwatchUrl20(colorway);
      if (swUrl) sw.style.backgroundImage = `url("${swUrl}")`;

      a.appendChild(sw);
      li.appendChild(a);
      ul.appendChild(li);
    });

    if (!ul.children.length) return;

    container.innerHTML = "";
    container.appendChild(ul);
  }

  async function init(root = document) {
    const containers = Array.from(root.querySelectorAll("[data-swatch-style]"))
      .filter(el => !el.dataset.swatchInit);

    if (!containers.length) return;

    // Mark now to avoid double work if init runs again quickly
    containers.forEach(el => (el.dataset.swatchInit = "1"));

    // Group by style
    const byStyle = new Map();
    containers.forEach(el => {
      const style = el.dataset.swatchStyle;
      if (!byStyle.has(style)) byStyle.set(style, []);
      byStyle.get(style).push(el);
    });

    // Fetch in parallel (but cached)
    const styles = Array.from(byStyle.keys());
    const pairs = await Promise.all(styles.map(async style => [style, await getProductsForStyle(style)]));

    const productsByStyle = Object.fromEntries(pairs);

    // Render into each container
    byStyle.forEach((els, style) => {
      const products = productsByStyle[style] || [];
      els.forEach(el => renderSwatches(el, products));
    });
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", () => init());

  // Shopify theme editor / dynamic sections
  document.addEventListener("shopify:section:load", (e) => init(e.target));
  document.addEventListener("shopify:section:reorder", (e) => init(e.target));

  // Catch carousels / infinite scroll / JS-rendered cards
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.("[data-swatch-style]") || node.querySelector?.("[data-swatch-style]")) {
          init(node);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();